import { Modal, Button, Container } from "react-bootstrap";
import { useSiteContext } from "../Providers/SSCProvider";
import "../../generic/css/ResponsiveForms.css";
import "../css/SiteCircuitManagement.css";
import "../css/InfoModal.css";

const CancelModal = ({ show, setShow, cancelConfirm }) => {
  const { selectedSite } = useSiteContext();
  const closeModal = () => setShow(false);
  const confirm = () => {
    setShow(false);
    cancelConfirm();
  };

  return (
    <>
      <Container>
        <Modal
          show={show}
          onHide={closeModal}
          centered
          dialogClassName="custom-modal"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          scrollable
        >
          <Modal.Body style={{ overflowY: "auto" }} className="w-150">
            <div className="mt-4 mb-4 ps-4">
              <Modal.Title>Discard changes made to:</Modal.Title>
              <h5>{selectedSite.siteName}</h5>
            </div>
            <Modal.Footer>
              <Button
                style={{
                  width: "80px",
                  color: "#707782",
                  backgroundColor: "#E5E7EB",
                  border: "none",
                }}
                onClick={closeModal}
              >
                Cancel
              </Button>
              <Button
                onClick={confirm}
                style={{
                  width: "80px",
                  color: "#FFFFFF",
                  backgroundColor: "#E02827",
                  border: "none",
                }}
              >
                Discard
              </Button>
            </Modal.Footer>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default CancelModal;
